import { render, staticRenderFns } from "./assessmentStatistics.vue?vue&type=template&id=513c7c93&scoped=true&"
import script from "./assessmentStatistics.vue?vue&type=script&lang=js&"
export * from "./assessmentStatistics.vue?vue&type=script&lang=js&"
import style0 from "./assessmentStatistics.vue?vue&type=style&index=0&id=513c7c93&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513c7c93",
  null
  
)

export default component.exports